import { render, staticRenderFns } from "./sell-data.vue?vue&type=template&id=6fb31456&scoped=true"
import script from "./sell-data.vue?vue&type=script&lang=js"
export * from "./sell-data.vue?vue&type=script&lang=js"
import style0 from "./sell-data.vue?vue&type=style&index=0&id=6fb31456&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb31456",
  null
  
)

export default component.exports